import { InputVariant } from '@pluxee-design-system/core';
import { ControllerFieldState, FieldValues, UseFormStateReturn } from 'react-hook-form';

export const getVariant = (
  { isSubmitted }: UseFormStateReturn<FieldValues>,
  { error, isTouched }: ControllerFieldState,
  isReadOnly?: boolean,
  skipSuccess?: boolean,
  skipVariant?: boolean,
) => {
  if (skipVariant) {
    return undefined;
  }
  if (isReadOnly) {
    return InputVariant.READONLY;
  }
  if (error) {
    return InputVariant.ERROR;
  }
  if ((isTouched || isSubmitted) && !skipSuccess) {
    return InputVariant.SUCCESS;
  }
  return InputVariant.FILLED;
};

export const getCheckBoxValue = (
  defaultValue: boolean,
  newValue: boolean,
  fieldValue: Record<string, unknown>,
  index: string,
) => {
  if (defaultValue === newValue) {
    const { [index]: _toRemove, ...rest } = fieldValue;
    return rest;
  } else {
    return {
      ...fieldValue,
      [index]: {
        oldState: defaultValue,
        newState: newValue,
      },
    };
  }
};
